
export default {
  head() {
    return {
      title: 'Privacy Policy',
    }
  },
}
